export default __webpack_public_path__ + "30ba1be3b7856cec1cf3376a462962ff.png";